import { render, staticRenderFns } from "./AccountMainModal.vue?vue&type=template&id=5cf200be&scoped=true&"
import script from "./AccountMainModal.vue?vue&type=script&lang=js&"
export * from "./AccountMainModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountMainModal.vue?vue&type=style&index=0&id=5cf200be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf200be",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CModalBody: require('@chakra-ui/vue').CModalBody, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
